import React from "react";

const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#FFF"
        d="M12 .5c3.176 0 6.05 1.287 8.132 3.368A11.464 11.464 0 0 1 23.5 12c0 3.176-1.287 6.05-3.368 8.132A11.464 11.464 0 0 1 12 23.5c-3.176 0-6.05-1.287-8.132-3.368A11.464 11.464 0 0 1 .5 12c0-3.176 1.287-6.05 3.368-8.132A11.464 11.464 0 0 1 12 .5Z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M10.46 17.15v-4.315H9.007v-1.716h1.451V9.762c0-.716.202-1.273.604-1.668.402-.396.936-.594 1.602-.594.54 0 .98.025 1.32.075v1.527h-.905c-.34 0-.572.075-.698.226-.1.126-.15.327-.15.603v1.188h1.602l-.227 1.716h-1.375v4.316h-1.773Z"
      />
    </g>
  </svg>
);

export default FacebookIcon;
